module.exports = __webpack_public_path__ + "static/workspace_preview-cbbd4c11e8f22b245e1d02394a362cf5.png";